import axios from "axios";
import { setAccessToken } from "services/AccessToken";
import { LogInResponse } from "types/responses/LogInResponse";
// import { LogInResponse } from "../types/responses/LogInResponse";
// import { UserI } from "../types/UserI";
import { ResponseError } from "types/responses/ResponseError"; 
import { UserI } from "types/UserI";
// import { setAccessToken } from "/AccessToken";

const API_URL = process.env.REACT_APP_API_URL;

async function LogInUserService(user_name: string, password: string) {
    // console.log(API_URL);

    // let url = "http://ec2-34-254-159-127.eu-west-1.compute.amazonaws.com:8080"
    try {
        const response = await axios.post(API_URL + '/login', {user_name: user_name, password: password});
        // console.log(response);

        
        if ('error' in response.data) {    
            // console.log("error");
            return response.data.error
        }

        if (!('user' in response.data) || !('access_token' in response.data)) {
            return "no_user_error"
        }
        
        const json:LogInResponse = JSON.parse(response.data.user)
        setAccessToken(response.data.access_token)
        
        let user: UserI = {
            client_id: json.ID_KLIENT || '-1',
            connection_id: json.ID_PRIHLASENI || '-1',
            credits: json.KREDIT || '0',
            email: json.EMAIL || '',
            first_name: json.JMENO || '',
            second_name: json.PRIJMENI || '',
            phone: json.TEL_MOB || '',
            membership: null,
            address: [json.ADRESA_1, json.ADRESA_2, json.ADRESA_3, json.ADRESA_4],
            birth_date: json.DAT_NAR
        }
        
        return user

    } catch (error) {
        // console.log("ERROR: LogInUser");
        // console.log(error);
        return ResponseError.general_error
    }
}


  

export default LogInUserService

